import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import StateCitySelector from "../../misc/StateCitySelector";
import { useDispatch, useSelector } from "react-redux";

import {
  getCourseDetail,
  getCourseList,
  getCourses,
} from "../../../store/actions/councilActions/courseAction";
import {
  addStudent,
  addStudentByAdmin,
  getApprovedCenters,
  getApprovedTrades,
  getStudent,
  registerStudentPublic,
  updateStudent,
} from "../../../store/actions/centerActions/studentAction";
import { useLocation, useParams } from "react-router-dom";
import TradeSubtradeSelector from "../../misc/TradeSubtradeSelector";
import Loader from "../../Alert/Loader";
import { updatePaymentStatus } from "../../../store/actions/centerActions/payment";

export default function AddStudent() {
  const location = useLocation();

const params = new URLSearchParams(location.search);
const nopay = params.get("nopay");
  const initialState = {
    mobile: "",
    alt_mobile: "",
    email: "",
    father_title: "",
    father_name: "",
    mother_title: "",
    mother_name: "",
    country: "",
    state: "",
    city: "",
    address: "",
    name: "",
    dob: "",
    course: "",
    gender: "",
    aadhar: "",
    merital_status: "",
    category: "",
    trade: "",
    sub_trade: "",
  };
  const [registration_date, setregistration_date] = useState("");
  const [data, setData] = useState(initialState);
  const {
    mobile,
    alt_mobile,
    email,
    father_title,
    father_name,
    mother_title,
    mother_name,
    category,
    country,
    state,
    city,
    address,
    name,
    dob,
    course,
    gender,
    aadhar,
    merital_status,
    trade,
    sub_trade,
  } = data;
  const dispatch = useDispatch();
  const { id } = useParams();
  const { search } = useLocation();
  const skipPayment = new URLSearchParams(search).get("nopay") === "icsmcode09";
  const { admin, center } = useSelector((state) => state);
  const formRef = useRef(null);
  const [roll_number, setroll_number] = useState("");
  const [submitting, setSubmitting] = useState(false);
  // Student admission declaration - required before a new admission is saved.
  const [declAccepted, setDeclAccepted] = useState(false);
  const [certificate10, setcertificate10] = useState([]);
  const [certificate12, setcertificate12] = useState([]);
  const [signature, setsignature] = useState([]);
  const [photo, setphoto] = useState([]);
  const [photoPreview, setphotoPreview] = useState(null);
  const [signaturePreview, setsignaturePreview] = useState(null);
  const [certificate10Preview, setcertificate10Preview] = useState(null);
  const [certificate12Preview, setcertificate12Preview] = useState(null);
  const { tradeCourses } = admin;
  const { centerAuth } = center;
  const { profile } = centerAuth;
  const [qualification, setqualification] = useState([
    {
      course: "",
      stream: "",
      board: "",
      year: "",
      marks_obtained: "",
      percentage: "",
    },
  ]);
  const [paymentStatus, setPaymentStatus] = useState(null); // null | 'success' | 'failed'
  const [razorpayPaymentId, setRazorpayPaymentId] = useState("");
  const [courseFee, setCourseFee] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");

  // The same form serves a center and the council. A center registers under
  // itself; the council has no center behind its login, so it says which
  // center the student belongs to and no fee is taken here - the council
  // records that on Add Student Fees, as it already does.
  const isAdmin = location.pathname.startsWith("/admin");
  // The same form again on the public website, where the student fills it in
  // themselves. They choose their center and pay the registration fee; only
  // then is a student written, so the form cannot be used to make rows.
  const isPublic = location.pathname.startsWith("/student-registration");
  // The admin still picks the centre. On the website there is no choice - every
  // website registration is filed under one centre, fixed on the server - so
  // the dropdown is shown for the admin only.
  const needsCenter = isAdmin;
  const [centerId, setCenterId] = useState("");
  const [centerList, setCenterList] = useState([]);
  const [registeredAs, setRegisteredAs] = useState(null);

  useEffect(() => {
    if (needsCenter && !id) {
      dispatch(getApprovedCenters()).then((list) =>
        setCenterList(Array.isArray(list) ? list : [])
      );
    }
  }, [needsCenter, id]);

  // A center only offers the courses it is approved for. Admin / public are not
  // restricted. Empty result (e.g. a center approved before this feature) also
  // means no restriction.
  const [approvedTrades, setApprovedTrades] = useState(null);
  useEffect(() => {
    if (!isAdmin && !isPublic) {
      dispatch(getApprovedTrades()).then((rows) =>
        setApprovedTrades(Array.isArray(rows) ? rows : null)
      );
    }
  }, [isAdmin, isPublic]);

  /**
   * A student registering themselves on the website.
   *
   * The order matters and is the same one the center form uses: the money is
   * recorded the instant Razorpay confirms it, before the student exists, so
   * a failure while saving can never lose a payment. The student is created
   * next, and the payment is attached to them last.
   */
  const handlePublicRegister = async () => {
    if (!formRef.current.reportValidity()) return;
    if (!declAccepted) {
      alert("Please read and accept the Declaration and Terms & Conditions.");
      return;
    }

    // No centre check here: the website does not ask for one. Every student
    // who registers on the site is filed under one fixed centre, decided on
    // the server.

    const amount = +courseFee?.fee?.registration_fee || 0;
    if (!amount) {
      alert(
        "The registration fee for this course has not been set. Please contact the council."
      );
      return;
    }

    setSubmitting(true);
    setPaymentStatus(null);

    const loaded = await new Promise((resolve) => {
      if (window.Razorpay) return resolve(true);
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

    if (!loaded) {
      alert("Razorpay could not be loaded. Please check your connection.");
      setSubmitting(false);
      return;
    }

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: amount * 100,
      currency: "INR",
      name: process.env.REACT_APP_META_NAME || "NSVEC",
      description: `Registration Fee | ${name}`,
      handler: async (razorpayResponse) => {
        const paymentId = razorpayResponse.razorpay_payment_id;
        setRazorpayPaymentId(paymentId);

        // 1. record the money first
        const feeData = new FormData();
        feeData.append("razorpay_payment_id", paymentId);
        feeData.append("amount", amount);
        feeData.append("registration_fee", amount);
        // the student paid it themselves, from the website
        feeData.append("deposited_by", "student");
        await dispatch(updatePaymentStatus(feeData));

        // 2. then create the student
        const formdata = new FormData();
        for (let [key, value] of Object.entries(data)) {
          formdata.append(
            key,
            Array.isArray(value) ? JSON.stringify(value) : value
          );
        }
        formdata.append("photo", photo);
        formdata.append("qualification", JSON.stringify(qualification));
        formdata.append("feesMode", "online");
        // no center_id: the server files every website student under its fixed centre
        formdata.append("razorpay_payment_id", paymentId);

        const studentRes = await dispatch(registerStudentPublic(formdata));

        if (studentRes && studentRes[0]) {
          // 3. attach the payment, which marks the registration fee paid
          const linkData = new FormData();
          linkData.append("razorpay_payment_id", paymentId);
          linkData.append("student_id", studentRes[0].id);
          linkData.append("deposited_by", "student");
          await dispatch(updatePaymentStatus(linkData));

          setPaymentStatus("success");
          setRegisteredAs(studentRes[0]);
          setData(initialState);
          setphotoPreview(null);
          setphoto([]);
          setCenterId("");
          setqualification([
            {
              course: "",
              stream: "",
              board: "",
              year: "",
              marks_obtained: "",
              percentage: "",
            },
          ]);
        } else {
          setPaymentStatus("paid-not-saved");
        }

        setSubmitting(false);
      },
      prefill: {
        name,
        email: email || "test@gmail.com",
        contact: mobile || "9999999999",
      },
      theme: { color: "#3399cc" },
      modal: { ondismiss: () => setSubmitting(false) },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", () => {
      setPaymentStatus("failed");
      setSubmitting(false);
    });
    rzp.open();
  };

  const handleAdminAdd = async () => {
    if (!formRef.current.reportValidity()) return;
    if (!declAccepted) {
      alert("Please read and accept the Declaration and Terms & Conditions.");
      return;
    }

    if (!centerId) {
      alert("Please choose the center this student belongs to.");
      return;
    }

    setSubmitting(true);
    const formdata = new FormData();
    for (let [key, value] of Object.entries(data)) {
      formdata.append(key, Array.isArray(value) ? JSON.stringify(value) : value);
    }
    formdata.append("photo", photo);
    formdata.append("qualification", JSON.stringify(qualification));
    formdata.append("feesMode", "offline");
    formdata.append("center_id", centerId);
    if (registration_date) {
      formdata.append("registration_date", registration_date);
    }

    const studentRes = await dispatch(addStudentByAdmin(formdata));
    if (studentRes) {
      setData(initialState);
      setphotoPreview(null);
      setphoto([]);
      setCenterId("");
      setqualification([
        {
          course: "",
          stream: "",
          board: "",
          year: "",
          marks_obtained: "",
          percentage: "",
        },
      ]);
    }
    setSubmitting(false);
  };
  // Center's configured mode decides the flow; "both" defers to the user's dropdown choice
  const effectivePaymentMode =
    profile?.payment_mode === "both" ? selectedPaymentMode : profile?.payment_mode;

  const handlePayFeeNow = async () => {
    // Validate all required fields before touching the server
    if (!formRef.current.reportValidity()) return;
    if (!declAccepted) {
      alert("Please read and accept the Declaration and Terms & Conditions.");
      return;
    }

    if (profile?.payment_mode === "both" && !effectivePaymentMode) {
      alert("Please select a payment mode.");
      return;
    }

    setSubmitting(true);
    setPaymentStatus(null);

    // Bypass payment gateway when the skip code is present in the URL, or the center is offline-only/chose offline
    if (skipPayment || effectivePaymentMode === "offline") {
      const formdata = new FormData();
      for (let [key, value] of Object.entries(data)) {
        formdata.append(key, Array.isArray(value) ? JSON.stringify(value) : value);
      }
      formdata.append("photo", photo);
      formdata.append("qualification", JSON.stringify(qualification));
      formdata.append("feesMode", "offline");
      const studentRes = await dispatch(addStudent(formdata));
      if (studentRes) {
        setData(initialState);
        setphotoPreview(null);
        setphoto([]);
        setqualification([
          { course: "", stream: "", board: "", year: "", marks_obtained: "", percentage: "" },
        ]);
      }
      setSubmitting(false);
      return;
    }

    // 1. Use already-fetched fee (loaded when user selected the course)
    const amount = +courseFee?.fee?.registration_fee || 0;

    if (!amount) {
      alert("Could not determine fee amount for the selected course.");
      setSubmitting(false);
      return;
    }

    // 2. Load Razorpay SDK
    const loaded = await new Promise((resolve) => {
      if (window.Razorpay) return resolve(true);
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

    if (!loaded) {
      alert("Razorpay SDK failed to load. Check your internet connection.");
      setSubmitting(false);
      return;
    }

    // 3. Open Razorpay modal
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: amount * 100, // paise
      currency: "INR",
      name: process.env.REACT_APP_META_NAME || "NSVEC",
      description: ` Registration Fee | ${name}${registration_date ? " | " + registration_date : ""}`,
      handler: async (razorpayResponse) => {
        const paymentId = razorpayResponse.razorpay_payment_id;
        setRazorpayPaymentId(paymentId);

        // 4. Record the payment BEFORE creating the student. The money has
        //    already left the center's account by this point, so it has to reach
        //    the database even if the student cannot be created afterwards
        //    (expired login, dropped connection, oversized photo). The record is
        //    written with no student attached; step 6 links it once one exists.
        const feeData = new FormData();
        feeData.append("razorpay_payment_id", paymentId);
        feeData.append("amount", amount);
        feeData.append("registration_fee", amount);
        // the center is paying, not the student
        feeData.append("deposited_by", "center");
        await dispatch(updatePaymentStatus(feeData));

        // 5. Money is safely recorded → now create the student
        const formdata = new FormData();
        for (let [key, value] of Object.entries(data)) {
          formdata.append(key, Array.isArray(value) ? JSON.stringify(value) : value);
        }
        formdata.append("photo", photo);
        formdata.append("qualification", JSON.stringify(qualification));
        formdata.append("feesMode", "online");
        formdata.append("razorpay_payment_id", paymentId);
        formdata.append("razorpay_order_id", razorpayResponse.razorpay_order_id);

        const studentRes = await dispatch(addStudent(formdata));

        if (studentRes) {
          // 6. Attach the payment recorded in step 4 to the new student, which
          //    also marks the registration fee as paid.
          const linkData = new FormData();
          linkData.append("razorpay_payment_id", paymentId);
          linkData.append("student_id", studentRes[0].id);
          linkData.append("deposited_by", "center");
          await dispatch(updatePaymentStatus(linkData));
          setPaymentStatus("success");

          // Only clear the form once the student is safely saved. On failure the
          // center keeps everything they typed.
          setData(initialState);
          setphotoPreview(null);
          setphoto([]);
          setqualification([
            { course: "", stream: "", board: "", year: "", marks_obtained: "", percentage: "" },
          ]);
        } else {
          // Paid, but not saved. The payment is already in the database from
          // step 4, so it is recoverable - the center must not pay again.
          setPaymentStatus("paid-not-saved");
        }

        setSubmitting(false);
      },
      prefill: { name, email: email || "test@gmail.com", contact: mobile || "9999999999" },
      theme: { color: "#3399cc" },
      modal: { ondismiss: () => setSubmitting(false) },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", () => {
      setPaymentStatus("failed");
      setSubmitting(false);
    });
    rzp.open();
  };
  const handleQualificationDetailChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...qualification];
    list[index][name] = value;
    setqualification(list);
  };
  const handleQualificationRemoveClick = (index) => {
    const list = [...qualification];
    list.splice(index, 1);
    setqualification(list);
  };
  const handleQualificationAddClick = () => {
    setqualification([
      ...qualification,
      {
        course: "",
        stream: "",
        board: "",
        year: "",
        marks_obtained: "",
        percentage: "",
      },
    ]);
  };
  useEffect(() => {
    if (sub_trade) {
      dispatch(getCourses(sub_trade));
    }
  }, [sub_trade]);

  useEffect(() => {
    if (course) {
      dispatch(getCourseDetail(course)).then((detail) => setCourseFee(detail || null));
    } else {
      setCourseFee(null);
    }
  }, [course]);

  useEffect(async () => {
    if (id) {
      const response = await dispatch(getStudent(id));
      if (response.isSuccess) {
        setData({
          ...data,
          mobile: response.student_details?.mobile,
          alt_mobile: response.student_details?.alt_mobile,
          email: response.student_details?.email,
          father_title: response.student_details?.father_title,
          father_name: response.student_details?.father_name,
          mother_title: response.student_details?.mother_title,
          mother_name: response.student_details?.mother_name,
          country: response.student_details?.country,
          state: response.student_details?.state,
          address: response.student_details?.address,
          city: response.student_details?.city,
          name: response.name,
          dob: response.dob,
          gender: response.gender,
          category: response.category,
          merital_status: response.merital_status,
          aadhar: response.aadhar,
          course: response.course?.id,
          trade: response.trade,
          sub_trade: response.sub_trade,
          feesMode: response.feesMode,

          // trade:response.stu
        });
        setroll_number(response.roll_number);
        setphotoPreview(
          response.student_file?.find(
            (file) => file.file_type == "Student Signature"
          )?.file || null
        );
        // setcertificate10Preview(
        //   response.student_file?.find(
        //     (file) => file.file_type == "10th Certificate"
        //   )?.file || null
        // );
        // setcertificate12Preview(
        //   response.student_file?.find(
        //     (file) => file.file_type == "12th Certificate"
        //   )?.file || null
        // );
        // setsignaturePreview(
        //   response.student_file?.find(
        //     (file) => file.file_type == "Student Signature"
        //   )?.file || null
        // );

        setqualification(response.qualification);
      }
    }
  }, []);

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    var formdata = new FormData();
    setSubmitting(true);

    for (let [key, value] of Object.entries(data)) {
      if (Array.isArray(value)) {
        formdata.append(key, JSON.stringify(value));
      } else {
        formdata.append(key, value);
      }
    }
    // handleSubmit only runs for edit/update
    formdata.append("roll_number", roll_number);
    formdata.append("student_id", id);
    if (photo) {
      formdata.append("photo", photo);
    }
    if (registration_date) {
      formdata.append("registration_date", registration_date);
    }
    dispatch(updateStudent(formdata, id));
    setSubmitting(false);
  };

  return (
    <div class="myForm">
      {/* <div class="formTitle">Center Code: {profile?.center_code} | Payment Mode: {profile?.payment_mode}</div> */}
      <div class="formTitle">
        {isPublic ? "Student Registration" : "Add Student"}
      </div>
      <Loader active={submitting} />

      {/* what to do next, once the fee is paid and the student is saved */}
      {registeredAs && (
        <div class="alert alert-success" style={{ borderRadius: "8px" }}>
          <strong>Registration complete.</strong> Your roll number is{" "}
          <code>{registeredAs.roll_number}</code>. Log in at{" "}
          <a href="/student/login">Student Login</a> with that roll number and
          the password <code>12345</code>, then change it from Change Password.
        </div>
      )}
      <form onSubmit={handleSubmit} ref={formRef}>
        <div class="row">
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-4">
                <div class="boxlabel">
                  <p>Student Full Name</p>
                  <input
                    type="text"
                    class="form-control"
                    name="name"
                    value={name}
                    onChange={handleChange}
                    required
                  />{" "}
                </div>
              </div>

              {id && (
                <div class="col-md-4">
                  <div class="boxlabel">
                    <p>Student Roll No</p>
                    <input
                      type="text"
                      class="form-control"
                      name="roll_number"
                      value={roll_number}
                      onChange={(e) => setroll_number(e.target.value)}
                      required
                    />{" "}
                  </div>
                </div>
              )}
              {/* backdating belongs to staff; the website registers today */}
              {!isPublic && (
                <div class="col-md-4">
                  <div class="boxlabel">
                    <p>Registration Date</p>
                    <input
                      type="date"
                      class="form-control"
                      name="registration_date"
                      value={registration_date}
                      onChange={(e) => setregistration_date(e.target.value)}
                      // required
                    />{" "}
                  </div>
                </div>
              )}

              {/*
                Which center the student joins. A center never sees this - the
                student is its own. The council does, because a student's
                center is the only thing its login cannot supply.
              */}
              {needsCenter && !id && (
                <div class="col-md-4">
                  <div class="boxlabel">
                    <p>Center</p>
                    <select
                      class="form-control"
                      name="center_id"
                      value={centerId}
                      onChange={(e) => setCenterId(e.target.value)}
                      required
                    >
                      <option value="">--Select Center--</option>
                      {centerList.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.center_name}
                          {c.center_code ? ` (${c.center_code})` : ""}
                          {c.center_city ? ` - ${c.center_city}` : ""}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              <div class="col-md-12">
                <div class="formTitle">Father’s/Husband Name</div>
              </div>
              <div class="col-md-4">
                <div class="boxlabel">
                  <p>Title </p>
                  <select
                    class="form-control"
                    name="father_title"
                    value={father_title}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select</option>
                    <option value="mr">Mr.</option>
                    <option value="dr">Dr.</option>
                    <option value="late">Late</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="boxlabel">
                  <p>Name </p>
                  <input
                    type="text"
                    class="form-control"
                    name="father_name"
                    value={father_name}
                    onChange={handleChange}
                    required
                  />{" "}
                </div>
              </div>
              <div class="col-md-12">
                <div class="formTitle">Mother Name</div>
              </div>
              <div class="col-md-4">
                <div class="boxlabel">
                  <p>Title </p>
                  <select
                    class="form-control"
                    name="mother_title"
                    value={mother_title}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select</option>
                    <option value="mrs">Mrs.</option>
                    <option value="ms">Ms.</option>
                    <option value="dr">Dr.</option>
                    <option value="late">Late</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="boxlabel">
                  <p>Name </p>
                  <input
                    type="text"
                    class="form-control"
                    name="mother_name"
                    value={mother_name}
                    onChange={handleChange}
                    required
                  />{" "}
                </div>
              </div>
              <div class="col-md-12"></div>
              <div class="col-md-4">
                <div class="boxlabel">
                  <p>Student Date of Birth</p>
                  <input
                    type="date"
                    class="form-control"
                    name="dob"
                    value={dob}
                    required
                    onChange={handleChange}
                  />{" "}
                </div>
              </div>
              <TradeSubtradeSelector
                data={data}
                setData={setData}
                approvedTrades={approvedTrades}
              />
              {sub_trade && (
                <div class="col-md-4">
                  <div class="boxlabel">
                    <p>Course Name </p>
                    <select
                      class="form-control"
                      name="course"
                      value={course}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled selected>
                        Select Course
                      </option>
                      {!tradeCourses ? (
                        <option value={""} disabled>
                          Loading...
                        </option>
                      ) : tradeCourses.length > 0 ? (
                        tradeCourses.map((course) => (
                          <option value={course.id}>{course.name}</option>
                        ))
                      ) : (
                        <option value={""} selected>
                          No Course Found
                        </option>
                      )}
                    </select>
                  </div>
                </div>
              )}

              {courseFee?.fee && (
                <div class="col-md-12">
                  <div
                    style={{
                      background: "#f0f7ff",
                      border: "1px solid #b3d4f5",
                      borderRadius: "8px",
                      padding: "12px 18px",
                      marginBottom: "12px",
                      display: "flex",
                      gap: "24px",
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "#1a6db5",
                        fontSize: "15px",
                      }}
                    >
                      Registration Fee: ₹{courseFee.fee.registration_fee}
                    </span>
                  </div>
                </div>
              )}

              <div class="row">
                <div class="col-md-3">
                  <div class="boxlabel">
                    <p>Gender</p>
                    <label class="Radioc">
                      Male
                      <input
                        type="radio"
                        checked={gender == "1"}
                        name="gender"
                        value="1"
                        onChange={handleChange}
                        required
                      />{" "}
                      <span class="checC"></span>{" "}
                    </label>
                    <label class="Radioc">
                      Female
                      <input
                        type="radio"
                        checked={gender == "2"}
                        name="gender"
                        value="2"
                        onChange={handleChange}
                      />{" "}
                      <span class="checC"></span>{" "}
                    </label>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="boxlabel">
                    <p>Category</p>
                    <label class="Radioc">
                      GEN
                      <input
                        type="radio"
                        checked={category == "1"}
                        name="category"
                        value="1"
                        onChange={handleChange}
                        required
                      />{" "}
                      <span class="checC"></span>{" "}
                    </label>
                    <label class="Radioc">
                      OBC
                      <input
                        type="radio"
                        checked={category == "2"}
                        name="category"
                        value="2"
                        onChange={handleChange}
                      />{" "}
                      <span class="checC"></span>{" "}
                    </label>
                    <label class="Radioc">
                      SC
                      <input
                        type="radio"
                        checked={category == "3"}
                        name="category"
                        value="3"
                        onChange={handleChange}
                      />{" "}
                      <span class="checC"></span>{" "}
                    </label>
                    <label class="Radioc">
                      ST
                      <input
                        type="radio"
                        checked={category == "4"}
                        name="category"
                        value="4"
                        onChange={handleChange}
                      />{" "}
                      <span class="checC"></span>{" "}
                    </label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="boxlabel">
                    <p>Marital Status</p>
                    <label class="Radioc">
                      Married
                      <input
                        type="radio"
                        checked={merital_status == "1"}
                        name="merital_status"
                        value="1"
                        onChange={handleChange}
                        required
                      />{" "}
                      <span class="checC"></span>{" "}
                    </label>
                    <label class="Radioc">
                      Unmarried
                      <input
                        type="radio"
                        name="merital_status"
                        value="2"
                        checked={merital_status == "2"}
                        onChange={handleChange}
                      />{" "}
                      <span class="checC"></span>{" "}
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="boxlabel">
                  <p>Email </p>
                  <input
                    type="text"
                    class="form-control"
                    name="email"
                    value={email}
                    required
                    onChange={handleChange}
                  />{" "}
                </div>
              </div>
              <div class="col-md-4">
                <div class="boxlabel">
                  <p>Contact No </p>
                  <input
                    type="text"
                    class="form-control"
                    name="mobile"
                    value={mobile}
                    required
                    onChange={handleChange}
                  />{" "}
                </div>
              </div>
              <div class="col-md-4">
                <div class="boxlabel">
                  <p>Alternate Number </p>
                  <input
                    type="text"
                    class="form-control"
                    name="alt_mobile"
                    value={alt_mobile}
                    // required
                    onChange={handleChange}
                  />{" "}
                </div>
              </div>

              <div class="col-md-8">
                <div class="boxlabel">
                  <p>Permanent Address </p>
                  <input
                    type="text"
                    class="form-control"
                    name="address"
                    value={address}
                    required
                    onChange={handleChange}
                  />{" "}
                </div>
              </div>
              <div class="col-md-4">
                <div class="boxlabel">
                  <p>Country </p>
                  <input
                    type="text"
                    class="form-control"
                    name="country"
                    value={country}
                    required
                    onChange={handleChange}
                  />{" "}
                </div>
              </div>
              <StateCitySelector
                user_city={city}
                user_state={state}
                set_user_state={(e) => setData({ ...data, state: e })}
                set_user_city={(e) => setData({ ...data, city: e })}
              />
              <div class="col-md-6">
                <div class="boxlabel">
                  <p>Aadhar Card No </p>
                  <input
                    type="text"
                    class="form-control"
                    name="aadhar"
                    maxlength="12"
                    value={aadhar}
                    onChange={handleChange}
                    // required
                  />{" "}
                </div>
              </div>
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table">
                    <thead class="thead-info">
                      <tr>
                        <th scope="col">Examination Passed </th>
                        <th scope="col">Name of Stream </th>
                        <th scope="col">Board/University </th>
                        <th scope="col">Year of Passing</th>
                        <th scope="col">Marks Obtained </th>
                        <th scope="col">%of Marks </th>
                        {qualification.length !== 1 && (
                          <th scope="col">Delete</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {qualification.map((qualify, index) => (
                        <tr>
                          <td>
                            <select
                              name="course"
                              value={qualify.course}
                              class="form-control"
                              onChange={(e) =>
                                handleQualificationDetailChange(e, index)
                              }
                            >
                              <option value={""}>--Select--</option>
                              <option value="10">10th</option>
                              <option value={"12"}>12th</option>

                              <option value={"ug"}>Graduation</option>
                              <option value={"pg"}>Post Graduation</option>
                            </select>
                          </td>
                          <td>
                            <input
                              type="text"
                              class="form-control"
                              name="stream"
                              value={qualify.stream}
                              onChange={(e) =>
                                handleQualificationDetailChange(e, index)
                              }
                              placeholder="ex. science"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              class="form-control"
                              name="board"
                              value={qualify.board}
                              onChange={(e) =>
                                handleQualificationDetailChange(e, index)
                              }
                              placeholder="Board/Univeristy"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              max={9999}
                              class="form-control"
                              name="year"
                              value={qualify.year}
                              onChange={(e) =>
                                handleQualificationDetailChange(e, index)
                              }
                              placeholder="ex. 2012"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              class="form-control"
                              name="marks_obtained"
                              value={qualify.marks_obtained}
                              onChange={(e) =>
                                handleQualificationDetailChange(e, index)
                              }
                              placeholder="ex. 500"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              class="form-control"
                              name="percentage"
                              onChange={(e) =>
                                handleQualificationDetailChange(e, index)
                              }
                              value={qualify.percentage}
                              placeholder="ex. 300"
                            />
                          </td>
                          {qualification.length !== 1 && (
                            <td>
                              <button
                                class="btn btn-add"
                                type="button"
                                onClick={() =>
                                  handleQualificationRemoveClick(index)
                                }
                              >
                                Remove
                              </button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div class="appendbtn text-right">
                    <button
                      class="btn btn-add"
                      type="button"
                      id="addstaff"
                      onClick={handleQualificationAddClick}
                    >
                      Add+
                    </button>
                  </div>
                </div>
              </div>

              {!id && profile?.payment_mode === "both" && (
                <div class="col-md-4">
                  <div class="boxlabel">
                    <p>Payment Mode</p>
                    <select
                      class="form-control"
                      name="selectedPaymentMode"
                      value={selectedPaymentMode}
                      onChange={(e) => setSelectedPaymentMode(e.target.value)}
                      required
                    >
                      <option value="">Select</option>
                      <option value="offline">Offline</option>
                      <option value="online">Online</option>
                    </select>
                  </div>
                </div>
              )}

              {/* <div class="col-md-4">
                <div class="Fileboxbale">
                  <div class="custom-file">
                    <input
                      type="file"
                      class="custom-file-input"
                      id="customFile2"
                      name="teenth"
                      // required
                      onChange={(e) => {
                        setcertificate10(e.target.files[0]);
                        setcertificate10Preview(
                          URL.createObjectURL(e.target.files[0])
                        );
                      }}
                    />
                    <label className="custom-file2" for="customFile2">
                      {certificate10Preview ? (
                        <img
                          src={certificate10Preview}
                          height={"100px"}
                          id="frontphoto"
                        />
                      ) : (
                        <>
                          <img src="/images/dummy.png" height={"100px"}></img>
                        </>
                      )}
                      <h4>10th Certificate</h4>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="Fileboxbale">
                  <div class="custom-file">
                    <input
                      type="file"
                      class="custom-file-input"
                      id="customFile3"
                      name="inter"
                      onChange={(e) => {
                        setcertificate12(e.target.files[0]);
                        setcertificate12Preview(
                          URL.createObjectURL(e.target.files[0])
                        );
                      }}
                    />
                    <label className="custom-file2" for="customFile3">
                      {certificate12Preview ? (
                        <img
                          src={certificate12Preview}
                          height={"100px"}
                          id="frontphoto"
                        />
                      ) : (
                        <>
                          <img src="/images/dummy.png" height={"100px"}></img>
                        </>
                      )}
                      <h4>12th Certificate</h4>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="Fileboxbale">
                  <div class="custom-file">
                    <input
                      type="file"
                      class="custom-file-input"
                      id="customFile5"
                      name="signphoto"
                      // required
                      onChange={(e) => {
                        setsignature(e.target.files[0]);
                        setsignaturePreview(
                          URL.createObjectURL(e.target.files[0])
                        );
                      }}
                    />
                    <label className="custom-file2" for="customFile5">
                      {signaturePreview ? (
                        <img
                          src={signaturePreview}
                          height={"100px"}
                          id="frontphoto"
                        />
                      ) : (
                        <>
                          <img src="/images/dummy.png" height={"100px"}></img>
                        </>
                      )}
                      <h4>Student Signature</h4>
                    </label>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div class="col-md-3">
            <div class="Fileboxbale">
              <div class="custom-file">
                <input type="hidden" value="" name="classphoto_old" />
                <input
                  type="file"
                  class="custom-file-input"
                  id="customFile"
                  name="studentpic"
                  // required
                  onChange={(e) => {
                    setphoto(e.target.files[0]);
                    setphotoPreview(URL.createObjectURL(e.target.files[0]));
                  }}
                />
                <label className="custom-file2" for="customFile">
                  {photoPreview ? (
                    <img src={photoPreview} height={"100px"} id="frontphoto" />
                  ) : (
                    <>
                      <img src="/images/dummy.png" height={"100px"}></img>
                    </>
                  )}
                  <h4>Student Photo</h4>
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            {paymentStatus === "success" && (
              <div
                class="alert alert-success mt-3"
                style={{ borderRadius: "8px" }}
              >
                <strong>Payment Successful!</strong> Payment ID:{" "}
                <code>{razorpayPaymentId}</code>
              </div>
            )}
            {paymentStatus === "failed" && (
              <div
                class="alert alert-danger mt-3"
                style={{ borderRadius: "8px" }}
              >
                <strong>Payment Failed.</strong> Please try again.
              </div>
            )}
            {paymentStatus === "paid-not-saved" && (
              <div
                class="alert alert-warning mt-3"
                style={{ borderRadius: "8px" }}
              >
                <strong>Payment received, student not saved.</strong> Your
                payment was successful and has been recorded. Payment ID:{" "}
                <code>{razorpayPaymentId}</code>
                <br />
                <strong>Please do not pay again.</strong> Your details are still
                on this form - contact the council with the payment ID above and
                the student will be added against this payment.
              </div>
            )}
            {!id && (
              <div className="check-box-div mt-3">
                <label
                  htmlFor="studentDecl"
                  style={{ cursor: "pointer", display: "inline-block" }}
                >
                  <input
                    type="checkbox"
                    className="check-button"
                    id="studentDecl"
                    checked={declAccepted}
                    onChange={() => setDeclAccepted(!declAccepted)}
                  />
                  <span style={{ fontSize: "14px", marginLeft: "6px" }}>
                    I have read and accept the{" "}
                    <a
                      href="/declaration/student-admission"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#d90001", fontWeight: 600 }}
                    >
                      Declaration and Terms &amp; Conditions
                    </a>
                    .
                  </span>
                </label>
              </div>
            )}
            <div
              class="btn-groups mt-4 text-right"
              role="group"
              aria-label="First group"
            >
              {id ? (
                <button class="btn btn-Next" type="submit" disabled={submitting}>
                  Submit
                  <span>
                    <svg width="35" height="12" viewBox="0 0 35 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M34.8403 6.00003C34.8403 6.2151 34.7582 6.43013 34.5943 6.5941L29.4346 11.7538C29.1063 12.0821 28.5742 12.0821 28.2461 11.7538C27.918 11.4257 27.918 10.8937 28.2461 10.5654L32.8117 6.00003L28.2462 1.43461C27.9181 1.10639 27.9181 0.574383 28.2462 0.246316C28.5743 -0.0820704 29.1065 -0.0820704 29.4347 0.246316L34.5945 5.40596C34.7584 5.57001 34.8403 5.78505 34.8403 6.00003Z" fill="white"></path>
                      <line x1="33.25" y1="5.94995" x2="0.75" y2="5.94995" stroke="white" stroke-width="1.5" stroke-linecap="round"></line>
                    </svg>
                  </span>
                </button>
              ) : (
                <button
                  class="btn btn-Next"
                  type="button"
                  disabled={submitting}
                  onClick={
                    isAdmin
                      ? handleAdminAdd
                      : isPublic
                      ? handlePublicRegister
                      : handlePayFeeNow
                  }
                >
                {isAdmin
                  ? "Submit"
                  : isPublic
                  ? "Register & Pay Fee"
                  : effectivePaymentMode === "offline"
                  ? "Submit"
                  : "Submit & Pay Fee"}
                  <span>
                    <svg width="35" height="12" viewBox="0 0 35 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M34.8403 6.00003C34.8403 6.2151 34.7582 6.43013 34.5943 6.5941L29.4346 11.7538C29.1063 12.0821 28.5742 12.0821 28.2461 11.7538C27.918 11.4257 27.918 10.8937 28.2461 10.5654L32.8117 6.00003L28.2462 1.43461C27.9181 1.10639 27.9181 0.574383 28.2462 0.246316C28.5743 -0.0820704 29.1065 -0.0820704 29.4347 0.246316L34.5945 5.40596C34.7584 5.57001 34.8403 5.78505 34.8403 6.00003Z" fill="white"></path>
                      <line x1="33.25" y1="5.94995" x2="0.75" y2="5.94995" stroke="white" stroke-width="1.5" stroke-linecap="round"></line>
                    </svg>
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
